import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2933 14.1666H59.96V36.6666H43.2933V14.1666Z",
			fill: "#3E2723"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.6267 27.3816V34.5249C46.6267 34.5249 47.4833 41.6683 51.6267 41.6683C55.77 41.6683 56.6267 34.5249 56.6267 34.5249V27.3816H46.6267Z",
			fill: "#EF8D3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.6267 15.2567C61.6267 6.85835 41.6267 9.78835 41.6267 15.2567V23.9284C41.6267 29.3917 46.1017 33.8284 51.6267 33.8284C57.15 33.8284 61.6267 29.3917 61.6267 23.9284V15.2567Z",
			fill: "#FFAA45"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.7933 22.0834C45.7933 21.395 46.3533 20.8334 47.0433 20.8334C47.7333 20.8334 48.2933 21.395 48.2933 22.0834C48.2933 22.7717 47.7333 23.3334 47.0433 23.3334C46.3533 23.3334 45.7933 22.7717 45.7933 22.0834ZM54.96 22.0834C54.96 22.7717 55.52 23.3334 56.21 23.3334C56.9 23.3334 57.46 22.7717 57.46 22.0834C57.46 21.395 56.9 20.8334 56.21 20.8334C55.52 20.8334 54.96 21.395 54.96 22.0834Z",
			fill: "#784719"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6267 5C44.7233 5 34.96 7.40833 34.96 30L43.2933 36.6667V20L56.6267 13.3333L59.96 18.485V36.6667L68.2933 30C68.2933 25.425 67.9067 7.27333 56.1717 7.27333L54.96 5H51.6267Z",
			fill: "#4E342E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.6267 35L56.5483 35.0183C56.27 36.6217 55.115 41.6667 51.6267 41.6667C48.1383 41.6667 46.9833 36.62 46.705 35.0183L46.6267 35C46.6267 35 33.3583 37.3217 33.335 50H33.2933V60H69.96V50.0333H70C70 37.3717 56.6267 35 56.6267 35Z",
			fill: "#3F51B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.6267 35L56.5483 35.0183C56.27 36.6217 55.115 41.6667 51.6267 41.6667C48.1383 41.6667 46.9833 36.62 46.705 35.0183L46.6267 35C46.6267 35 33.3583 37.3217 33.335 50H33.2933V60H69.96V50.0333H70C70 37.3717 56.6267 35 56.6267 35Z",
			fill: "#3F51B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6267 45C56.745 45 59.065 39.7233 59.7717 35.955C57.955 35.2367 56.6267 35 56.6267 35L56.5483 35.0183C56.27 36.6217 55.115 41.6667 51.6267 41.6667C48.1383 41.6667 46.9833 36.62 46.705 35.0183L46.6267 35C46.6267 35 45.2967 35.235 43.4817 35.9533C44.1883 39.7217 46.5083 45 51.6267 45Z",
			fill: "#1A237E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.6667 32.5C36.6667 33.88 35.5467 35 34.1667 35C32.785 35 31.6667 33.88 31.6667 32.5C31.6667 31.12 32.785 30 34.1667 30C35.5467 30 36.6667 31.12 36.6667 32.5ZM18.3333 32.5C18.3333 33.88 17.2133 35 15.8333 35C14.4533 35 13.3333 33.88 13.3333 32.5C13.3333 31.12 14.4533 30 15.8333 30C17.2133 30 18.3333 31.12 18.3333 32.5Z",
			fill: "#FFA726"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.3733 60.0333C43.3733 47.3717 30 45 30 45L25.04 46.1867L20 45C20 45 6.73166 47.3217 6.70833 60H6.66666V63.3333H43.3333V60.0333H43.3733Z",
			fill: "#4FC3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 50C20 50 20 45 20 45V38.3334H30V45C30 45 30 50 25 50Z",
			fill: "#FF9800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 53.3333C30.5283 53.3333 32.865 49.2617 33.2633 46.0067C31.3883 45.2517 30 45 30 45C30 45 30 50 25 50C20 50 20 45 20 45C20 45 18.61 45.25 16.7367 46.005C17.135 49.2617 19.4717 53.3333 25 53.3333Z",
			fill: "#01579B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 25.2567C35 16.8584 15 19.7884 15 25.2567V33.9284C15 39.3917 19.475 43.8284 25 43.8284C30.5233 43.8284 35 39.3917 35 33.9284V25.2567Z",
			fill: "#FFB74D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 25.2567C35 16.8584 15 19.7884 15 25.2567V33.9284C15 39.3917 19.475 43.8284 25 43.8284C30.5233 43.8284 35 39.3917 35 33.9284V25.2567Z",
			fill: "#FFB74D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 15C17.9117 15 13.3333 21.2883 13.3333 26.9167V30L16.6667 33.3333V28.3333L30 23.3333L33.3333 26.6667V33.3333L36.6667 30V28.4033C36.6667 23.71 35.455 18.4833 29.6667 17.3317L28.3333 15H25Z",
			fill: "#795548"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1667 32.0834C19.1667 32.7717 19.7267 33.3334 20.4167 33.3334C21.1067 33.3334 21.6667 32.7717 21.6667 32.0834C21.6667 31.395 21.1067 30.8334 20.4167 30.8334C19.7267 30.8334 19.1667 31.395 19.1667 32.0834ZM28.3333 32.0834C28.3333 32.7717 28.8933 33.3334 29.5833 33.3334C30.2733 33.3334 30.8333 32.7717 30.8333 32.0834C30.8333 31.395 30.2733 30.8334 29.5833 30.8334C28.8933 30.8334 28.3333 31.395 28.3333 32.0834Z",
			fill: "#784719"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.3333 58.3333C73.3333 67.5383 65.87 75 56.6667 75C47.4617 75 40 67.5383 40 58.3333C40 49.1283 47.4617 41.6666 56.6667 41.6666C65.87 41.6666 73.3333 49.1283 73.3333 58.3333Z",
			fill: "#43A047"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.3333 48.3334H60V68.3334H53.3333V48.3334Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.6667 55H66.6667V61.6667H46.6667V55Z",
			fill: "white"
		})
	]
});
export default SvgAddUsers;
